import { ThumbsUp, TrendingUp } from 'lucide-react';
import { CoachingOverview } from '../../../types/meetinganalysis';

interface CoachingOverviewTabProps {
  coachingOverview: CoachingOverview;
}

export const CoachingOverviewTab: React.FC<CoachingOverviewTabProps> = ({
  coachingOverview,
}) => {
  return (
    <div className="p-6">
      <h2 className="text-m font-medium mb-4">Overview</h2>
      <p className="text-gray-700 text-sm leading-relaxed mb-8">
        {coachingOverview.overview}
      </p>

      {/* Two Column Layout */}
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        {/* Key Strengths */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-m font-semibold mb-4 flex items-center">
            <ThumbsUp className="w-4 h-4 mr-2 text-green-500" />
            Key Strengths
          </h2>

          <div className="space-y-6">
            {coachingOverview.keyStrengths.map((strength, index) => (
              <div key={index}>
                <p className="text-gray-700 text-sm mb-2">
                  <li>{strength.strength}</li>
                </p>
                <div className="bg-gray-50 p-4 rounded-lg text-gray-600 text-sm italic">
                  "{strength.quote}"
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Areas for Improvement */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-m font-semibold mb-4 flex items-center">
            <TrendingUp className="w-6 h-6 mr-2 text-yellow-500" />
            Areas for Improvement
          </h2>

          <div className="space-y-6">
            {coachingOverview.areasForImprovement.map((area, index) => (
              <div key={index}>
                <p className="text-gray-700 text-sm mb-2">
                  <li>{area.area}</li>
                </p>
                <div className="bg-gray-50 p-4 rounded-lg text-gray-600 text-sm italic">
                  "{area.quote}"
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Suggested Next Steps */}
      <div>
        <h3 className="text-m font-medium mb-4">Suggested next steps</h3>
        <ul className="list-disc pl-5 text-gray-700 text-sm space-y-2">
          {coachingOverview.suggestedNextSteps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
